import React from 'react';
import './CircularProgress.css'; // CSS dosyasını import ediyoruz

const CircularProgress = () => {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );
};

export default CircularProgress;
